import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from '../app/home/home.component';
import {ProductlistComponent} from '../app/productlist/productlist.component';
import {ProductdetailsComponent} from '../app/productdetails/productdetails.component';
import {CheckoutComponent} from '../app/checkout/checkout.component';
import {CheckoutItemComponent} from '../app/checkout-item/checkout-item.component';
import {MyordersComponent} from '../app/myorders/myorders.component';
import {MyordersListsComponent} from '../app/myorders-lists/myorders-lists.component';
import {MyaccountComponent} from '../app/myaccount/myaccount.component';
import {SigninComponent} from '../app/auth/signin/signin.component';
import {SignupComponent} from '../app/auth/signup/signup.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { OrdersucesspageComponent } from './ordersucesspage/ordersucesspage.component';
import { AddresspageComponent } from './addresspage/addresspage.component';
import { EManageAddressComponent } from './e-manage-address/e-manage-address.component';
import { EEditAddressComponent } from './e-edit-address/e-edit-address.component';
import { EEditProfileComponent } from './e-edit-profile/e-edit-profile.component';
import { ESearchComponent } from './e-search/e-search.component';

export const routes: Routes = [
  { path: '',      component: HomeComponent },
  { path: 'productlists/:cat/:title',           component: ProductlistComponent },
  { path: 'productdetails/:animal',          component: ProductdetailsComponent },
  { path: 'checkout',           component: CheckoutComponent },
  { path: 'myorders',  component: MyordersListsComponent },
  { path: 'myaccount',  component: MyaccountComponent },
  { path: 'signup',  component: SignupComponent },
  { path: 'signin',  component: SigninComponent },
  { path: 'wishlist',  component: WishlistComponent },
  { path: 'placed/:oid',  component: OrdersucesspageComponent },
  { path: 'address',  component: AddresspageComponent },
  { path: 'search',  component: ESearchComponent },

  { path: 'manageaddress',  component: EManageAddressComponent },
  { path: 'editaddress',  component: EEditAddressComponent },
  { path: 'editprofile',  component: EEditProfileComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
